import { render, staticRenderFns } from "./v-order.vue?vue&type=template&id=1e0dbd48&"
import script from "./v-order.vue?vue&type=script&lang=js&"
export * from "./v-order.vue?vue&type=script&lang=js&"
import style0 from "./v-order.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports